// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-list-item__icon[data-v-3a87c082]  .v-image{filter:grayscale(35%)}.filter-info[data-v-3a87c082]  p{margin:8px 0}.filter-info[data-v-3a87c082]  h2{margin:16px 0 8px 0;font-size:18px}.filter-info[data-v-3a87c082]  ul{margin:8px 0}.scrollbar[data-v-3a87c082]::-webkit-scrollbar{width:9px}.scrollbar[data-v-3a87c082]::-webkit-scrollbar-track{background:transparent}.scrollbar[data-v-3a87c082]::-webkit-scrollbar-thumb{background-color:#eff0fd;border-radius:20px}", ""]);
// Exports
module.exports = exports;
